import React from 'react';
import { SvgIcon } from '@mui/material';

export function DoneIcon({ isSm }) {
  return isSm ? (
    <SvgIcon sx={{ width: 17, height: 16 }} viewBox="0 0 17 16" fill="none">
      <path
        d="M11.5795 1.33301H5.79953C3.53953 1.33301 2.01953 2.91967 2.01953 5.27967V10.7263C2.01953 13.0797 3.53953 14.6663 5.79953 14.6663H11.5795C13.8395 14.6663 15.3529 13.0797 15.3529 10.7263V5.27967C15.3529 2.91967 13.8395 1.33301 11.5795 1.33301Z"
        fill="#29EDFF"
      />
      <path
        d="M7.89614 10.165C7.7468 10.165 7.59747 10.1083 7.48347 9.99432L5.90147 8.41232C5.67347 8.18432 5.67347 7.81498 5.90147 7.58765C6.12947 7.35965 6.49814 7.35898 6.72614 7.58698L7.89614 8.75698L10.6481 6.00498C10.8761 5.77698 11.2448 5.77698 11.4728 6.00498C11.7008 6.23298 11.7008 6.60232 11.4728 6.83032L8.3088 9.99432C8.1948 10.1083 8.04547 10.165 7.89614 10.165Z"
        fill="#4520AB"
      />
    </SvgIcon>
  ) : (
    <SvgIcon sx={{ width: 25, height: 25 }} viewBox="0 0 25 25" fill="none">
      <path
        d="M16.34 2.80859H7.67C4.28 2.80859 2 5.18859 2 8.72859V16.8986C2 20.4286 4.28 22.8086 7.67 22.8086H16.34C19.73 22.8086 22 20.4286 22 16.8986V8.72859C22 5.18859 19.73 2.80859 16.34 2.80859Z"
        fill="#29EDFF"
      />
      <path
        d="M10.813 16.057C10.589 16.057 10.365 15.972 10.194 15.801L7.82095 13.428C7.47895 13.086 7.47895 12.532 7.82095 12.191C8.16295 11.849 8.71595 11.848 9.05795 12.19L10.813 13.945L14.941 9.81705C15.283 9.47505 15.836 9.47505 16.178 9.81705C16.52 10.159 16.52 10.713 16.178 11.055L11.432 15.801C11.261 15.972 11.037 16.057 10.813 16.057Z"
        fill="#4520AB"
      />
    </SvgIcon>
  );
}
